import React, { useRef } from 'react';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import { useNavigate, useParams } from 'react-router-dom';
import SignatureCanvas from 'react-signature-canvas';

import { formatDateTime } from '../Utils/GlobalUtils';
import { useTimeModal } from '../Components/TimeModal/TimeModalContext';

import ModalRight from '../Components/ModalRight';
import FileViewerModal from '../Components/FileViewerModal';
import FileUploadField from '../Components/FileUploadField';

import HeadlinePanel from '../Components/HeadlinePanel';
import WarningPanel from '../Components/WarningPanel';
import Loading from '../Components/Loading';

import { AddNewSignatureComponent } from '../Components/AddNewSignatureComponent';

export default function Signature() {
  const { openTimeModal } = useTimeModal();
  const sigCanvas = useRef(null);
  const navigate = useNavigate();

  let { id: routeId } = useParams();

  const [currentSignature, setCurrentSignature] = React.useState('');
  const [warning, setWarning] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [reload, setReload] = React.useState(true);

  React.useEffect(() => {
      const token = localStorage.getItem('token');
      if (!token) {
          navigate('/auth/login');
          return;
      }

      try {
          const decodedToken = jwtDecode(token);

          if (Number(routeId) !== Number(decodedToken.id)) {
            if (decodedToken.role !== 'АппаратСРО') {
              navigate('/404');
              return;
            }
          }
      } catch (error) {
          console.error('Ошибка при декодировании токена: ', error);
          navigate('/home');
      }
  }, [routeId]);

  React.useEffect(() => {
    if (!routeId) return;
    const token = localStorage.getItem('token');

    setLoading(true);

    axios.get(`/api/get-user-signature?user_id=${routeId}`, {
      headers: {
          Authorization: `Bearer ${token}`,
      }
    }).then(response => {
        setCurrentSignature(response.data);
    })
    .catch(error => {
        setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
    })
    .finally(() => {
      setReload(false);
      setLoading(false);
    })
  }, [reload, routeId]);

  const [isFileViewerModal, setIsFileViewerModal] = React.useState(false);


  return (
    <>
      <ModalRight isOpen={isFileViewerModal} closeModal={() => setIsFileViewerModal(false)} >
          <FileViewerModal closeModal={() => setIsFileViewerModal(false)} id={currentSignature.file_id} />
      </ModalRight>

      <div className='mainContainer'>
        <HeadlinePanel label='Подпись' />
        <div className='containerInner'>
          <div className='pageWrapper'>
            <div className='pageLimiter'>
                {loading ? <Loading />
                : warning ? <WarningPanel text={warning} buttonText='Повторить попытку' buttonAction={() => setReload(true)} />
                : 
                <>
                <div className='panel'>
                  <div className='panelHeader'>
                      <h3>Нынешняя подпись</h3>
                  </div>
                  <div className='panelMain'>
                    <div className='horizontalContainer' style={{fontSize: '14px'}}>
                      <p>Создана {formatDateTime(currentSignature.created_at)}</p>
                      <a className='aWithLink' onClick={() => setIsFileViewerModal(true)}>Просмотреть</a>
                    </div>
                  </div>
                </div>
                </>}

                {!loading && <AddNewSignatureComponent userId={routeId} onReloadContent={() => setReload(true)} />}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}